import React, {createElement, Fragment, useEffect, useMemo, useRef, useState} from "react";
import {render} from "react-dom";
import { useSelector } from "react-redux";
import {autocomplete} from "@algolia/autocomplete-js";
import {Hits} from "react-instantsearch-dom";
import {Box} from "@chakra-ui/react";
import PropTypes from "prop-types";
import drillcut_star from "../image/drillcut_star.svg";
import {useLocation, useNavigate} from "react-router-dom";
import qs from "qs";
// import insights from 'search-insights';
import AlgoliaEventManager from '../services/AlgoliaEventManager';
import { AnalyticsBrowser } from '@segment/analytics-next';
import aa from 'search-insights';

export const analytics = AnalyticsBrowser.load({ writeKey: 'he0xS0CTKAKAnjsVcfzfcrqdBSIe1H4d' });

function createURL(searchState) {
    return qs.stringify(searchState, { addQueryPrefix: true });
}
const AlgoliaCustom2 = (props) => {
    const location = useLocation();
    const [autoCompleteState, setAutoCompleteState] = useState({});
    const [lastClickQueryID, setLastClickQueryID] = useState('');
    const [lastConversionQueryID, setLastConversionQueryID] = useState('');
    const containerRef = useRef(null);
    const isAboveRef = useRef(false);
    const debounceTimeoutRef = useRef(null);

    const navigate = useNavigate();

     const {
        isLoggedIn, loginEmail, customerAccessToken, currentDebtorId, allUserInfo
    } = useSelector(state => state.user);

    useEffect(() => {
        if (!containerRef.current) {
            return undefined;
        }

        // 1. Initialize insights client.
        // insights('init', {
        //     appId: process.env.REACT_APP_ALGOLIA_APPLICATION_ID,
        //     apiKey: process.env.REACT_APP_ALGOLIA_API_KEY, // search-only API key
        //     useCookie: true,
        // });

        // Set user info for AlgoliaEventManager
        AlgoliaEventManager.setUserInfo({ isLoggedIn, allUserInfo });
        AlgoliaEventManager.setAlgoliaUserProfile();

        const search = autocomplete({
            container: containerRef.current,
            aa, // Pass the initialized client
            clickAnalytics: true, // Enable analytics
            renderer: {createElement, Fragment, render},
            onStateChange(props) {
                var state = props.state;
                const now = new Date();
                const dateTimeString = now.toLocaleString();
                
                // Clear previous timeout
                if (debounceTimeoutRef.current) {
                    clearTimeout(debounceTimeoutRef.current);
                }
                
                // fire Algolia Insights event for all filtered items when search is submitted
                if (state.query && state.query.length > 0 && state.collections && state.collections[0] && state.collections[0].items) {                
                    // Debounce the insights call - only execute after user stops typing for 2 seconds
                    debounceTimeoutRef.current = setTimeout(() => {
                        const allHits = state.collections[0].items;
                        const queryID = allHits[0]?.__autocomplete_queryID;
                        const objectIDs = allHits.map(item => item.objectID);
                        if (objectIDs.length > 0 && queryID) {
                            AlgoliaEventManager.sendView(
                                'Products Searched',
                                objectIDs,
                                { queryID }
                            );
                        }
                    }, 2000); // 2 seconds debounce - adjust as needed
                }
                
                if (!autoCompleteState.isOpen && !state.isOpen && state.query !== undefined && state.query.length > 0) {
                    setTimeout(() => {
                    setAutoCompleteState(prevState => {
                        if (prevState.isOpen === true && state.isOpen === false && location.pathname !== '/search' && isAboveRef.current !== false) {
                            return prevState;
                        }
                        return state
                    });
                }, 300);
                } else {
                    setAutoCompleteState(props.state);
                }
            },
            ...props,
        });

        return () => {
            if (debounceTimeoutRef.current) {
                clearTimeout(debounceTimeoutRef.current);
            }
            search.destroy();
        };
    }, [props.plugins, location, isLoggedIn, allUserInfo?.id]);
//    const [lastViewQueryID, setLastViewQueryID] = useState('');
//    useEffect(() => {
//     let dwellTimeout;
//     if (autoCompleteState.isOpen && autoCompleteState.collections.length > 0) {
//         const firstCollection = autoCompleteState.collections[0];
//         const objectIDs = firstCollection.items.map(item => item.objectID);
//         const queryID = firstCollection.items[0]?.__autocomplete_queryID;
//         if (objectIDs.length > 0 && queryID) {
//             dwellTimeout = setTimeout(() => {
//                 insights('viewedObjectIDs', {
//                     eventName: 'Products Viewed',
//                     index: 'shopify_products',
//                     objectIDs: objectIDs,
//                     queryID: queryID,
//                 });
//                 analytics.then(([response]) => {
//                     response.track('Products Viewed', {
//                         product_ids: objectIDs,
//                         search_index: 'shopify_products',
//                         userId: allUserInfo?.id,
//                         searchQuery: autoCompleteState.query,
//                         query_id: queryID,
//                         eventType: 'view',
//                     });
//                 });
//                 setLastViewQueryID(queryID);
//             }, 1000); // 1s dwell
//         }
//     }
//     return () => clearTimeout(dwellTimeout);
// }, [autoCompleteState, allUserInfo?.id, lastViewQueryID]);

    function capitalize(allwords){
        return allwords.replace(/^(.)|\s+(.)/g, c => c.toUpperCase());
    }

    useEffect(() => {
        const prefixWrappers = document.querySelectorAll('.aa-InputWrapperPrefix');

        prefixWrappers.forEach(prefixWrapper => {
            // Find the aa-Label within the current prefix wrapper
            const label = prefixWrapper.querySelector('.aa-Label');

            // Get the corresponding suffix wrapper (next sibling of the prefix wrapper's parent)
            const suffixWrapper = prefixWrapper.parentElement.querySelector('.aa-InputWrapperSuffix');

            // Move the label to the suffix wrapper if both are found
            if (label && suffixWrapper) {
                suffixWrapper.appendChild(label);
            }
        });
    }, [window,location]);

    useEffect(() => {
        // console.log(location.pathname)
        if (location.pathname.includes('/products')) {
            isAboveRef.current = false;
        }
    }, [location]);

    useEffect(() => {
        if (isLoggedIn && allUserInfo?.id) {
            analytics.then(([response]) => {
                response.identify(String(allUserInfo.id), {
                    email: allUserInfo.email || '',
                    name: `${allUserInfo.firstname || ''} ${allUserInfo.lastname || ''}`.trim(),
                    company: allUserInfo.company || '',
                    phone: allUserInfo.phone || '',
                });
            });
        }
    }, [isLoggedIn, allUserInfo?.id]);

    //console.log(autoCompleteState);

    return <div className="ais-SearchBox searchBox_searchPage">
        <div ref={containerRef}/>
        {autoCompleteState.isOpen && (
            <div data-test={allUserInfo?.id}
                // ref={panelRef}
                className={[
                    'custom-aa-Panel',
                    'aa-Panel',
                    'aa-Panel--desktop',
                    autoCompleteState.status === 'stalled' && 'aa-Panel--stalled',
                ]
                    .filter(Boolean)
                    .join(' ')}

                style={{width: '100%'}}
            >
                <div className="aa-PanelLayout aa-Panel--scrollable" onMouseEnter={event => {
                    isAboveRef.current = true;
                }} onMouseLeave={event => {
                    isAboveRef.current = false;
                }}>
                    {autoCompleteState.collections.map((collection, index) => {
                        const {source, items} = collection;
                        return (<section key={`source-${index}`} className="aa-Source">
                                {items.length > 0 && (
                                    <ul className="aa-List">
                                        {items.map((item) => {                                            
                                            return (
                                                <li
                                                    key={item.objectID}
                                                    onClick={() => {
                                                        const queryID = autoCompleteState?.collections?.[0]?.items?.[0]?.__autocomplete_queryID;
                                                        const position = items.findIndex(it => it.objectID === item.objectID) + 1;
                                                        if (queryID) {
                                                            setTimeout(() => {
                                                                AlgoliaEventManager.sendClick(
                                                                    'Product Clicked',
                                                                    [item.objectID],
                                                                    {
                                                                        queryID: queryID,
                                                                        positions: [position]
                                                                    }
                                                                );
                                                                analytics.then(([response]) => {
                                                                    response.track('Product Clicked', {
                                                                        product_id: item.objectID,
                                                                        search_index: 'shopify_products',
                                                                        userId: allUserInfo.id,
                                                                        productName: item.title,
                                                                        eventName: 'Product Clicked',
                                                                        eventType: 'click',
                                                                        searchQuery: autoCompleteState.query,
                                                                        query_id: queryID,
                                                                        position: position,
                                                                    });
                                                                });
                                                                // insights('convertedObjectIDsAfterSearch', {
                                                                //     eventName: 'Product Converted',
                                                                //     index: 'shopify_products',
                                                                //     objectIDs: [item.objectID],
                                                                //     queryID: queryID,
                                                                // });
                                                                // analytics.then(([response]) => {
                                                                //     response.track('Product Converted', {
                                                                //         product_id: item.objectID,
                                                                //         search_index: 'shopify_products',
                                                                //         userId: allUserInfo.id,
                                                                //         eventName: 'Product Converted',
                                                                //         eventType: 'conversion',
                                                                //         query_id: queryID,
                                                                //     });
                                                                // });
                                                                setLastConversionQueryID(queryID);
                                                            }, 1000); // 1s dwell
                                                        }
                                                        

                                                        if (item.handle) {
                                                            // Navigate to the product page if handle is defined
                                                            navigate(`/products/${item.handle}`, { state: { algoliaHit: item } });
                                                        } else if (item.redirect) {
                                                            if (item.redirect.startsWith('http://') || item.redirect.startsWith('https://')) {
                                                                window.location.href = item.redirect;
                                                            } else {
                                                                // Navigate internally if it's a relative URL
                                                                navigate(item.redirect);
                                                            }
                                                        } else {
                                                            // Perform a query string search if neither handle nor redirect are defined
                                                            navigate(`/search${createURL({ query: item.title })}`);
                                                        }
                                                        setAutoCompleteState(prevState => {
                                                            return {
                                                                ...prevState,
                                                                isOpen: false,
                                                            };
                                                        });
                                                    }}
                                                    className="aa-Item">
                                                    <div className="aa-ItemWrapper">
                                                        <div className="aa-ItemContent">
                                                            <div
                                                                className="aa-ItemIcon aa-ItemIcon--picture aa-ItemIcon--alignTop">
                                                                <img
                                                                    loading="lazy"
                                                                    src={item.image ? item.image : drillcut_star}
                                                                    alt={item.name}
                                                                    width="40"
                                                                    height="40"
                                                                />
                                                            </div>
                                                            <div className="aa-ItemContentBody">
                                                                {item.title ? item.title : capitalize(autoCompleteState.query)}
                                                            </div>

                                                        </div>
                                                        <div className="aa-ItemActions">
                                                            <button
                                                                className="aa-ItemActionButton aa-DesktopOnly aa-ActiveOnly"
                                                                type="button"
                                                                title="Select"
                                                                aria-label="Select"
                                                            >
                                                                <svg fill="currentColor" viewBox="0 0 24 24">
                                                                    <path
                                                                        d="M18.984 6.984h2.016v6h-15.188l3.609 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.609 3.609h13.172v-4.031z"/>
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </li>
                                            );
                                        })}
                                        {index > 0 && index === 1 ? (
                                            <li className="aa-Item">
                                                Press the search button or Enter for more results
                                            </li>) : ''}
                                    </ul>
                                )}
                            </section>
                        );
                    })}
                </div>
            </div>
        )}
    </div>
        ;
};


export default AlgoliaCustom2;
